(() => {
const key='LBEventsLandingV2';
if (window[key]) { window[key].init(); return; }
const rootFor=() => document.getElementById('lbe');
const formHashes=['#suggest-an-event', '#LBEventSuggestionForm'];
const feedUrl='https://script.google.com/macros/s/AKfycbx3YsKos834PFOvsfordNBtiS-RGpU8RKElkCQFy2np8cFScYSMQVypJrUIrmIs9jw/exec';
let feedPayload=null;
let feedLoading=false;
let feedTimer=null;
const make=(tag,className,text) => {
const node=document.createElement(tag);
if (className) node.className=className;
if (text !== undefined && text !== null) node.textContent=text;
return node;
};
const pacificTime=value => {
if (!value) return 'Time to be announced';
const date=new Date(value);
if (Number.isNaN(date.getTime())) return 'Time to be announced';
try {
return new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',weekday:'long',month:'long',day:'numeric',year:'numeric',hour:'numeric',minute:'2-digit',timeZoneName:'short'}).format(date);
} catch (_) { return date.toLocaleString(); }
};
const shortDescription=value => {
const lines=String(value || '').split(/\r?\n/).map(line => line.trim()).filter(line => line && !/^https?:\/\//i.test(line) && !/^#+\s*$/.test(line));
const copy=lines[0] || 'Join David and the Luxurious Bastard Brotherhood live on YouTube.';
return copy.length > 240 ? copy.slice(0,237).trimEnd() + '...' : copy;
};
const renderFeed=(root,payload) => {
const grid=root?.querySelector('[data-lbe-youtube-grid]');
const empty=root?.querySelector('[data-lbe-youtube-empty]');
const status=root?.querySelector('[data-lbe-feed-status]');
if (!grid || !empty || !status) return;
grid.replaceChildren();
const events=Array.isArray(payload?.events) ? payload.events.filter(event => event && (event.status === 'live' || event.status === 'upcoming')).slice(0,6) : [];
events.sort((a,b) => {
if (a.status === 'live' && b.status !== 'live') return -1;
if (b.status === 'live' && a.status !== 'live') return 1;
return new Date(a.scheduledStartTime || 0)-new Date(b.scheduledStartTime || 0);
});
if (!events.length) {
grid.hidden=true;
empty.hidden=false;
status.textContent='No upcoming stream is currently scheduled.';
return;
}
events.forEach(event => {
const isLive=event.status === 'live';
const article=make('article','v19 lbe-youtube-card');
article.dataset.lbeStatus=isLive ? 'live' : 'upcoming';
const media=make('div','v20');
const fallback=make('div','v21');
fallback.setAttribute('aria-hidden','true');
fallback.append(make('b','',isLive ? 'Live now' : 'Coming up'),make('span','','Luxurious Bastard · YouTube Live'));
media.append(fallback);
if (event.thumbnail) {
const img=make('img');
img.src=String(event.thumbnail);
img.width=1280;
img.height=720;
img.loading='lazy';
img.decoding='async';
img.alt=String(event.title || 'Luxurious Bastard live stream') + ' thumbnail';
img.addEventListener('error',() => { img.hidden=true; },{once:true});
media.append(img);
}
const body=make('div','v22');
body.append(make('span','v23',isLive ? 'Live now · YouTube' : 'Upcoming · YouTube Live'));
body.append(make('h3','',event.title || 'Luxurious Bastard Live Stream'));
const meta=make('div','lbe-youtube-meta');
const when=make('span');
when.append(make('b','',isLive ? 'Started' : 'When'),document.createTextNode(pacificTime(event.actualStartTime || event.scheduledStartTime)));
const where=make('span');
where.append(make('b','','Where'),document.createTextNode('The Luxurious Bastard YouTube channel'));
meta.append(when,where);
body.append(meta,make('p','lbe-live-description',shortDescription(event.description)));
const actions=make('div','v26');
const link=make('a','v7',isLive ? 'Watch live now' : 'Set a reminder on YouTube');
link.href=event.url || 'https://www.youtube.com/@TheLuxuriousBastard/streams';
actions.append(link);
body.append(actions);
article.append(media,body);
grid.append(article);
});
empty.hidden=true;
grid.hidden=false;
status.textContent=events.some(event => event.status === 'live') ? 'We are live right now.' : 'Automatically updated from YouTube.';
};
const feedFailed=() => {
feedLoading=false;
if (feedTimer) clearTimeout(feedTimer);
const root=rootFor();
const status=root?.querySelector('[data-lbe-feed-status]');
if (status) status.textContent='The YouTube schedule is temporarily unavailable. Use the channel links below.';
};
const loadFeed=() => {
const root=rootFor();
if (!root) return;
if (feedPayload) { renderFeed(root,feedPayload); return; }
if (feedLoading || !feedUrl) return;
feedLoading=true;
feedTimer=setTimeout(feedFailed,15000);
fetch(feedUrl + (feedUrl.includes('?') ? '&' : '?') + 'v=' + Date.now(),{
method:'GET',
mode:'cors',
cache:'no-store',
redirect:'follow',
headers:{Accept:'application/json'}
})
.then(response => {
if (!response.ok) throw new Error('Feed request failed');
return response.json();
})
.then(payload => {
feedLoading=false;
if (feedTimer) clearTimeout(feedTimer);
if (!payload || payload.success !== true) { feedFailed(); return; }
feedPayload=payload;
renderFeed(rootFor(),payload);
})
.catch(feedFailed);
};
const reveal=() => {
const root=rootFor();
if (!root || !formHashes.includes(location.hash)) return;
const details=root.querySelector('.v44');
if (details) details.open=true;
};
const init=() => {
const root=rootFor();
if (!root || root.dataset.lbeReady) return;
root.dataset.lbeReady='true';
reveal();
loadFeed();
const form=root.querySelector('#LBEventSuggestionForm');
const details=root.querySelector('.v44');
if (form && details) form.addEventListener('invalid', () => { details.open=true; }, true);
const status=root.querySelector('[data-lbe-status]');
if (status) requestAnimationFrame(() => status.focus());
root.querySelectorAll('img[data-lbe-image]').forEach(img => {
const fallback=() => { img.hidden=true; };
img.addEventListener('error', fallback, { once: true });
if (img.complete && img.naturalWidth === 0) fallback();
});
const filters=root.querySelector('[data-lbe-filters]');
const cards=[...root.querySelectorAll('[data-lbe-upcoming] .v19')];
if (filters && cards.length) {
filters.hidden=false;
const buttons=[...filters.querySelectorAll('[data-lbe-filter]')];
const count=filters.querySelector('[data-lbe-results]');
const empty=root.querySelector('[data-lbe-filter-empty]');
const apply=mode => {
let shown=0;
cards.forEach(card => { card.hidden=mode !== 'all' && card.dataset.lbeMode !== mode; if (!card.hidden) shown++; });
buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lbeFilter === mode)));
if (count) count.textContent=shown + (shown === 1 ? ' event' : ' events');
if (empty) empty.hidden=shown > 0;
};
buttons.forEach(button => {
if (button.dataset.lbeFilter === 'online') button.textContent='Live schedule';
button.addEventListener('click', () => {
const mode=button.dataset.lbeFilter;
if (mode === 'online') {
const target=root.querySelector('.lbe-live-head') || root.querySelector('#live-streams');
if (target) {
if (!target.id) target.id='lbe-live-schedule';
try { history.replaceState(null,'','#' + target.id); } catch (_) {}
target.scrollIntoView({behavior:'smooth',block:'start'});
return;
}
}
apply(mode);
});
});
apply('all');
}
};
window[key]={ init };
window.addEventListener('hashchange', reveal);
document.addEventListener('click', event => {
const link=event.target.closest && event.target.closest('a[href]');
if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
let url;
try { url=new URL(link.href, location.href); } catch (_) { return; }
if (url.origin === location.origin && url.pathname === location.pathname && formHashes.includes(url.hash)) {
const details=rootFor()?.querySelector('.v44');
if (details) details.open=true;
}
});
document.addEventListener('shopify:section:load', init);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
init();
})();